import makeRules from "@/mixins/makeRules";
import ValueDataRules from "@/mixins/ValueDataRules";
import copy from "@/services/copy";

export default function(mapPhysique, mapMorale) {
  return {
    mixins: [makeRules(), ValueDataRules],
    data() {
      const out = {
        prefix: null,
        type: null,
        indexTab: 0,
        tabDisabled: false,
        modal: false,
      };
      mapPhysique({}, out);
      mapMorale({}, out);
      return out;
    },
    watch: {
      indexTab() {
        this.syncType();
      },
    },
    methods: {
      //appeler par le parent
      valeur() {
        const out = { type: this.type, prefix: this.prefix };
        if ("physique" === this.type) {
          mapPhysique(this, out);
        } else {
          mapMorale(this, out);
        }
        return out;
      },
      syncType() {
        if (this.indexTab === 0) {
          this.type = "physique";
        } else if (this.indexTab === 1) {
          this.type = "morale";
        }
      },
      edite(valeur, next) {
        valeur = copy(valeur);
        this.prefix = valeur.prefix;
        this.type = valeur.type;

        mapPhysique(valeur, this);
        mapMorale(valeur, this);

        this.tabDisabled = true;
        this.next = next;
        this.modal = true;
        this.$nextTick(() => {
          this.indexTab = "physique" === this.type ? 0 : 1;
          this.$refs.form.validate();
        });
      },
      nouveau(next) {
        this.tabDisabled = false;
        this.next = next;
        this.uuid = null;
        this.localUuid = null;
        this.estFondateur = true;
        this.modal = true;
        this.$nextTick(() => {
          this.indexTab = 0;
          this.syncType();
          this.$refs.form.reset();
        });
      },
      ferme() {
        this.modal = false;
      },
      validateForm() {
        //active/désactive la validation serveur
        try {
          this.validation.disabled = true;
          return this.$refs.form.validate();
        } finally {
          this.validation.disabled = false;
        }
      },
      valide() {
          if (this.validateForm()) {
            this.next(this.valeur());
            this.ferme();
          }
      },
    },
  };
}
